'use client';

import { usePathname, useSelectedLayoutSegments } from 'next/navigation';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';
import { CONSENT_TOOL_STORAGE_KEYS } from '@/lib/constants';
import sendGTMEvent from '@/lib/send-gtm-event';

function checkShouldTrack() {
  if (
    typeof window === 'undefined' ||
    typeof window.dataLayer === 'undefined' ||
    localStorage.getItem(
      `${CONSENT_TOOL_STORAGE_KEYS.cookieChoicePrefix}analytics`,
    ) !== 'true'
  ) {
    return false;
  }

  return window.dataLayer.some((entry: unknown) => {
    if (typeof entry !== 'object' || entry === null) return false;

    return (entry as { event?: unknown }).event === 'gtm.js';
  });
}

export default function TrackPageView({
  isOfficeRequest,
}: {
  isOfficeRequest: boolean;
}) {
  const locale = useLocale();
  const pathname = usePathname();
  const segments = useSelectedLayoutSegments();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    gtag('consent', 'default', {
      ad_personalization: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      analytics_storage: 'denied',
    });

    sendGTMEvent({ isOfficeRequest });
    sendGTMEvent({ blockGoogleAnalytics: true });
    sendGTMEvent({ blockGoogleAds: true });
    sendGTMEvent({ blockPageView: true });
  }, [isOfficeRequest]);

  useEffect(() => {
    if (!checkShouldTrack()) return;

    const pageId =
      segments[0] === 'press' && segments.length > 1
        ? 'about.press.article'
        : `about.${segments[0]}`;

    sendGTMEvent({
      event: 'page_view',
      event_name: 'page',
      page: {
        languageSettings: locale,
        pageId,
        pageType: pageId,
      },
    });
  }, [locale, pathname, segments]);

  return <></>;
}
